import { useRef } from 'react';
import { Carousel, Col, Row, Button } from 'antd';
import RenderFeatureCard from './feature-card';
import './style.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import Tripflex from "@assets/images/home/tripflex.jpg";
import Conference from "@assets/images/home/conference.jpg";
import Points from "@assets/images/home/double-points.jpg";
import Stay from "@assets/images/home/extend-stay.jpg";
// import "antd/dist/antd.css";


const DiscoverFeatures = () => {
  const carouselRef = useRef(null);
  const intl = useIntl();

  const goToNext = () => {
    carouselRef.current.next();
  };

  const goToPrev = () => {
    carouselRef.current.prev();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 3, 
    responsive: [ 
      {
        breakpoint: 575, // Smaller screens
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]  
  }; 

  const moreFeaturesData = [
    {
      title: intl.formatMessage({ id: 'dashboard.features.tripflex.title' }),
      description: intl.formatMessage({ id: 'dashboard.features.tripflex.description' }),
      buttonText: intl.formatMessage({ id: 'dashboard.features.tripflex.button' }),
      buttonLink: "#",
      imageSrc: Tripflex,
    },
    {
      title: intl.formatMessage({ id: 'dashboard.features.grouptrip.title' }),
      description: intl.formatMessage({ id: 'dashboard.features.grouptrip.description' }),
      buttonText: intl.formatMessage({ id: 'dashboard.features.grouptrip.button' }),
      buttonLink: "#",
      imageSrc: Conference,
    },
    {
      title: intl.formatMessage({ id: 'dashboard.features.earnpoints.title' }),
      description: intl.formatMessage({ id: 'dashboard.features.earnpoints.description' }),
      buttonText: intl.formatMessage({ id: 'dashboard.features.earnpoints.button' }),
      buttonLink: "#",
      imageSrc: Points,
    },
    {
      title: intl.formatMessage({ id: 'dashboard.features.extendedstay.title' }),
      description: intl.formatMessage({ id: 'dashboard.features.extendedstay.description' }),
      buttonText: intl.formatMessage({ id: 'dashboard.features.extendedstay.button' }),
      buttonLink: "#",
      imageSrc: Stay,
    },
  ];
  return (
    <section className='paddingTop-0'> 
      <div className="container-fluid">

        <div
          className="discover-features-container"
          style={{ position: 'relative' }}
        >
          <Row justify="center" className="mb-4">
            <Col span={24} style={{ textAlign: 'center' }}>
              <h2><FormattedMessage id="dashboard.discover.features" /></h2>
            </Col>
          </Row>
          <div className="discover-features-card">
            {moreFeaturesData.map((card, index) => (
              <RenderFeatureCard key={index} card={card} />
            ))}
          </div>
          <div className="carsousel mb-md-6 mb-0 position-relative">
            <Button className='left-arrow'
              style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)' }}
              type="text"
              onClick={goToPrev}
            >
              {/* <LeftOutlined style={{ fontSize: '24px' }} /> */}
              <i className="bi bi-arrow-left" ></i>
            </Button>
            <Carousel ref={carouselRef} {...settings}>
              {moreFeaturesData.map((card, index) => (
                <div key={index}>
                  <RenderFeatureCard card={card} />
                </div>
              ))}
            </Carousel>
            <Button
              className='right-arrow'
              style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}
              type="text"
              onClick={goToNext}
            >
              {/* <RightOutlined style={{ fontSize: '24px' }} /> */}
              <i className="bi bi-arrow-right"></i>
            </Button>
          </div>
        </div>

      </div>
    </section>
  );
};

export default DiscoverFeatures;
